export default theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  aggregatedTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(2),
  },
});
